import { Link } from 'react-router-dom';
import { useEffect } from 'react';

function SwipeRushTerms() {
    useEffect(function () { window.scrollTo(0, 0); }, []);
    return (
        <div className={"swiperush-page"}>
            <div className={"swiperush-content legal-page"}>
                <div className={"legal-header"}>
                    <Link to={"/products/swiperush"} className={"back-link"}>&larr; Back to SwipeRush</Link>
                    <h1>Terms of Service</h1>
                    <p className={"effective-date"}>Effective Date: March 15, 2026</p>
                </div>

                <section className={"legal-section"}>
                    <h2>1. Acceptance of Terms</h2>
                    <p>
                        By downloading, installing, or using SwipeRush ("the App"), you agree to be bound by these
                        Terms of Service ("Terms"). If you do not agree to these Terms, do not use the App.
                        SwipeRush is developed and operated by Nuevo Alture Tech Ventures LLP (NA Tech Ventures).
                    </p>
                </section>

                <section className={"legal-section"}>
                    <h2>2. Use of the App</h2>
                    <p>You agree to use SwipeRush only for lawful purposes and in accordance with these Terms. You agree not to:</p>
                    <ul>
                        <li>Use the App in any way that violates applicable laws or regulations</li>
                        <li>Exploit, cheat, or use unauthorized modifications in the game</li>
                        <li>Interfere with or disrupt the integrity or performance of the App</li>
                        <li>Attempt to gain unauthorized access to the App or its related systems</li>
                        <li>Use the App to harass, abuse, or harm other users</li>
                    </ul>
                </section>

                <section className={"legal-section"}>
                    <h2>3. User Accounts</h2>
                    <p>
                        You may be required to create an account to access certain features of SwipeRush. You are responsible
                        for maintaining the confidentiality of your account credentials and for all activities that occur under
                        your account. You agree to notify us immediately of any unauthorized use of your account.
                    </p>
                </section>

                <section className={"legal-section"}>
                    <h2>4. Intellectual Property</h2>
                    <p>
                        All content, features, and functionality of SwipeRush, including but not limited to text, graphics,
                        logos, icons, images, audio, and software, are the exclusive property of Nuevo Alture Tech Ventures LLP
                        and are protected by copyright, trademark, and other intellectual property laws.
                    </p>
                </section>

                <section className={"legal-section"}>
                    <h2>5. In-App Purchases</h2>
                    <p>
                        SwipeRush may offer in-app purchases. All purchases are final and non-refundable unless required
                        by applicable law. You are responsible for all charges incurred through your account.
                    </p>
                </section>

                <section className={"legal-section"}>
                    <h2>6. Disclaimer of Warranties</h2>
                    <p>
                        SwipeRush is provided on an "AS IS" and "AS AVAILABLE" basis. We make no warranties, expressed or
                        implied, regarding the App's operation or the information, content, or materials included therein.
                        To the fullest extent permitted by law, we disclaim all warranties.
                    </p>
                </section>

                <section className={"legal-section"}>
                    <h2>7. Limitation of Liability</h2>
                    <p>
                        In no event shall Nuevo Alture Tech Ventures LLP be liable for any indirect, incidental, special,
                        consequential, or punitive damages arising out of or related to your use of SwipeRush. Our total
                        liability shall not exceed the amount you have paid to us in the twelve (12) months preceding the claim.
                    </p>
                </section>

                <section className={"legal-section"}>
                    <h2>8. Termination</h2>
                    <p>
                        We reserve the right to terminate or suspend your access to SwipeRush at any time, without prior
                        notice or liability, for any reason, including breach of these Terms.
                    </p>
                </section>

                <section className={"legal-section"}>
                    <h2>9. Changes to Terms</h2>
                    <p>
                        We may revise these Terms at any time by updating this page. By continuing to use SwipeRush after
                        those revisions become effective, you agree to be bound by the revised Terms.
                    </p>
                </section>

                <section className={"legal-section"}>
                    <h2>10. Contact Us</h2>
                    <p>
                        If you have any questions about these Terms of Service, please contact us at:
                    </p>
                    <p><strong>Email:</strong> <a href="mailto:contact@nuevoalture.com">contact@nuevoalture.com</a></p>
                    <p><strong>Company:</strong> Nuevo Alture Tech Ventures LLP</p>
                </section>
            </div>
        </div>
    );
}

export default SwipeRushTerms;
